(function () {
        'use strict';

        angular
            .module('jotApp')
            .controller('MyDomainNotificationDialogController', MyDomainNotificationDialogController);

        MyDomainNotificationDialogController.$inject = ['$uibModal', '$timeout', '$filter', '$scope', '$stateParams', 'entity', 'Warning', 'WarningCategory', 'TabFleets', 'UserProfile', '$state', 'ParseLinks', 'AlertService', 'MyDomainNotification', 'AlertRules'];

        function MyDomainNotificationDialogController($uibModal, $timeout, $filter, $scope, $stateParams, entity, Warning, WarningCategory, TabFleets, UserProfile, $state, ParseLinks, AlertService, MyDomainNotification, AlertRules) {
            var vm = this;
            vm.myDomainNotification = entity;
            vm.fleetOptions = [];
            vm.categoryOptions = [];
            vm.warningNameOptions = [];
            vm.fleetSelectedAtStart = [];
            vm.categorySelectedAtStart = [];
            vm.warningSelectedAtStart = [];

            vm.fleetEmpty = true;
            vm.categoryEmpty = true;

            vm.isEdit = false;
            vm.isClone = false;
            vm.isCreate = false;
            vm.notificationSystems = ['email', 'telegram'];

            if (vm.myDomainNotification.name != null) {
                vm.nameBeforeSave = vm.myDomainNotification.name;
            }

            vm.timepickerOptions = {showMeridian: false};
            vm.repeatStatus = false;
            vm.openTimeCalc = function () {
                $timeout(function () {
                    vm.repeatStatus = true;
                });
            };

            vm.userProfiles = UserProfile.alertsProfile({
                page: 0,
                size: 100
            });
           vm.currentUserProfile =MyDomainNotification.getCurrentUserProfile({
                page: 0,
                size: 100
            });
           vm.currentUserProfile.$promise.then(function (data) {
               vm.currentUserProfile = data;
           })

            vm.tabFleets = TabFleets.query({
                page: 0,
                size: 100
            });
            vm.categories = WarningCategory.query({
                page: 0,
                size: 100
            });
            vm.systemWarnings = AlertRules.querySystem({
                page: 0,
                size: 1000
            });
            vm.warningNames = AlertRules.query({
                page: 0,
                size: 1000
            });

            vm.tabFleets.$promise.then(function (fleets) {
                fleets.forEach(function (fleet) {
                    vm.fleetOptions.push({id: fleet.id, label: fleet.fleetName});
                });
                vm.categories.$promise.then(function (categories) {
                    categories.unshift({id: -1, warningName: 'system'});
                    vm.systemWarnings.$promise.then(function (systemWarnings) {
                        systemWarnings.warnings.forEach((systemWarning) => {
                            systemWarning.warningCategory = {id: -1, warningName: "system"};
                        });
                        vm.systemWarnings = vm.systemWarnings.warnings;
                        vm.warningNames.$promise.then(function (warnings) {
                            vm.systemWarnings.forEach((systemWarning) => {
                                warnings.warnings.unshift(systemWarning);
                            });

                            vm.warningNames = vm.warningNames.warnings;

                            // Map name > rules[]
                            vm.warningNameMap = {};
                            vm.warningNames.forEach(function (warning) {
                                var name = warning.name;
                                if (!vm.warningNameMap[name]) {
                                    vm.warningNameMap[name] = [];
                                }
                                vm.warningNameMap[name].push(warning);
                            });

                            vm.precompile();
                        })
                    })
                });
            });

            $timeout(function () {
                angular.element('.form-group:eq(1)>input').focus();
            });

            // Dato l'array di rules in input, restituisce un array di rules con warning names univoci
            function dedupeByName(warnings) {
                const map = new Map();
                warnings.forEach(w => {
                    if (!map.has(w.name)) {
                        map.set(w.name, w);
                    }
                });
                return Array.from(map.values());
            }

            vm.save = function () {
                vm.myDomainNotification.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                if (vm.myDomainNotification.name === vm.nameBeforeSave && vm.isClone) {
                    $uibModal.open({
                        templateUrl: 'app/entities/my-domain-notification/modals/my-domain-notification-duplicate-name.html',
                        controller: function ($uibModalInstance) {
                            var vm = this;
                            vm.clear = clear;

                            function clear() {
                                $uibModalInstance.dismiss('cancel');
                            }
                        },
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', function ($translate) {
                                return $translate.refresh();
                            }],
                        }
                    })
                    return
                }

                collectFleets();
                collectCategories();
                collectWarnings();

                vm.myDomainNotification.fleets = angular.copy(vm.selectedFleets);
                vm.myDomainNotification.categories = angular.copy(vm.selectedCategories);
                vm.myDomainNotification.warningNames = angular.copy(vm.selectedWarnings);

                MyDomainNotification.update(vm.myDomainNotification, onSaveSuccess, onSaveError);
            };

            var onSaveSuccess = function (result) {
                if (vm.isClone || vm.isCreate) {
                    vm.notificationSystems.forEach(system => {
                        vm.saveToggle(system, result);
                    });
                } else {
                    $state.go('my-domain-notification', null, {reload: true});
                }
            };
            var onSaveError = function () {
                vm.isSaving = false;
            };

            vm.saveToggle = function (type, notification) {
                vm.channel = {};
                vm.channel.alertSystemType = {};
                vm.channel.alertSystemType.name = type;
                vm.channel.active = true;
                vm.channel.myDomainNotification = notification;
                MyDomainNotification.insertDomainAlerts({
                    myDomainNotificationAlertConfiguration: vm.channel,
                    myDomainNotification: notification,
                    users: vm.alertUsers
                }, function (result) {
                    notification = result;
                    vm.setAlertConf();
                });
            };

            vm.setAlertConf = function () {
                vm.alertUsers = [];
                vm.email = {};
                vm.telegram = {};
                vm.email.exist = false;
                vm.telegram.exist = false;
                vm.myDomainNotification.myDomainNotificationAlertConfigurations.forEach(function (mdnac) {
                    vm[mdnac.alertSystemType.name].exist = true;
                    vm[mdnac.alertSystemType.name].mdnac = mdnac;
                    if (mdnac.active)
                        vm[mdnac.alertSystemType.name].active = true;
                });
                $state.go('my-domain-notification', null, {reload: true});
            };

            vm.clear = function () {
                $state.go('my-domain-notification');
            };
            vm.refreshIndex = function () {
                vm.myDomainNotification.index = null;
                vm.tempMetric = [];
            };

            function onFleetSelect(fleets) {

                vm.categoryBeforeFleetselect = angular.copy(vm.myDomainNotification.categories);

                // vm.categoryOptionsBeforeFleetselect = angular.copy(vm.categoryOptions);

                vm.categoryOptions = [];
                vm.fleetEmpty = false;

                var categoryIds = [];
                fleets.forEach(fleet => {
                    vm.warningNames.forEach(warning => {
                        if (warning.tabFleets.id == fleet.id) {
                            vm.categoryOptions.forEach(function (option) {
                                categoryIds.push(option.id);
                            })
                            if (!categoryIds.includes(warning.warningCategory.id)) {
                                vm.categoryOptions.push({
                                    id: warning.warningCategory.id,
                                    label: warning.warningCategory.warningName
                                });
                            }
                        }
                    })
                })

                // Selected options that match by id remain selected, additional options are not selected automatically
                vm.myDomainNotification.categories = vm.categoryBeforeFleetselect.filter(prev =>
                    vm.categoryOptions.some(opt => opt.id === prev.id)
                );

                // if (vm.categoryBeforeFleetselect.length > 0) {
                //     vm.myDomainNotification.categories = angular.copy(vm.categoryBeforeFleetselect);
                //     var categoryIds2 = [];
                //     vm.categoryOptionsBeforeFleetselect.forEach(oldCategory => {
                //         categoryIds2.push(oldCategory.id);
                //     })
                //     vm.categoryOptions.forEach(categoryOption => {
                //         if (!categoryIds2.includes(categoryOption.id)) {
                //             vm.myDomainNotification.categories.push(categoryOption);
                //         }
                //     })
                // } else {
                //     vm.myDomainNotification.categories = angular.copy(vm.categoryOptions);
                // }

                // onCategorySelect(vm.myDomainNotification.categories);
            }

            function onFleetDeselect(fleets) {

                if (fleets.length > 0) {

                    vm.categoryBeforeFleetDeselect = angular.copy(vm.myDomainNotification.categories);

                    vm.categoryOptions = [];
                    vm.fleetEmpty = false;

                    var categoryIds2 = [];
                    fleets.forEach(fleet => {
                        vm.warningNames.forEach(warning => {
                            if (warning.tabFleets.id == fleet.id) {
                                vm.categoryOptions.forEach(function (option) {
                                    categoryIds2.push(option.id);
                                })
                                if (!categoryIds2.includes(warning.warningCategory.id))
                                    vm.categoryOptions.push({
                                        id: warning.warningCategory.id,
                                        label: warning.warningCategory.warningName
                                    });
                            }
                        })
                    })

                    // Selected options that match by id remain selected, additional options are not selected automatically
                    vm.myDomainNotification.categories = vm.categoryBeforeFleetDeselect.filter(prev =>
                        vm.categoryOptions.some(opt => opt.id === prev.id)
                    );

                    // for (var x = 0; x < vm.categoryBeforeFleetDeselect.length; x++) {
                    //     if (!categoryIds2.includes(vm.categoryBeforeFleetDeselect[x].id)) {
                    //         vm.categoryBeforeFleetDeselect.splice(x, 1);
                    //     }
                    // }
                    // if (vm.categoryBeforeFleetDeselect.length > 0) {
                    //     vm.myDomainNotification.categories = angular.copy(vm.categoryBeforeFleetDeselect);
                    // } else {
                    //     vm.myDomainNotification.categories = angular.copy(vm.categoryOptions);
                    // }


                    onCategoryDeselect(vm.myDomainNotification.categories);

                } else {

                    // vm.myDomainNotification.fleets = [];

                    vm.fleetEmpty = true;
                    vm.categoryEmpty = true;

                    // Nessuna flotta selezionata > nessuna categoria e warning name selezionati
                    vm.myDomainNotification.categories = [];
                    vm.myDomainNotification.warningNames = [];
                }
            }

            function onCategorySelect(categories) {

                // vm.warningBeforeCategorySelect = angular.copy(vm.myDomainNotification.warningNames);
                // vm.warningOptionsBeforeCategorySelect = angular.copy(vm.warningNameOptions);

                vm.warningNameOptions = [];
                vm.categoryEmpty = false;

                var fleetOptionsIds = [];

                vm.myDomainNotification.fleets.forEach(function (fleet) {
                    fleetOptionsIds.push(fleet.id)
                })

                // Set warning name options
                var warningNamesMap = new Map();
                categories.forEach(category => {
                    vm.warningNames.forEach(warning => {
                        if (warning.warningCategory.id === category.id && fleetOptionsIds.includes(warning.tabFleets.id)) {
                            warning.label = warning.name;
                            warningNamesMap.set(warning.name, warning);
                        }
                    })
                })
                vm.warningNameOptions = Array.from(warningNamesMap.values());

                // Selected options that match by name remain selected, additional options are not selected automatically
                var finalSelection = [];
                vm.myDomainNotification.warningNames.forEach(selected => {

                    // 1. Retrieves full object by id
                    var fullObj = vm.warningNames.find(w => w.id === selected.id);
                    if (!fullObj) return;

                    // 2. Find object with same name in options
                    var match = vm.warningNameOptions.find(opt => opt.name === fullObj.name);
                    if (!match) return;

                    // 3. Add object to final selection
                    finalSelection.push(match);
                });

                vm.myDomainNotification.warningNames = finalSelection;


                // if (vm.warningBeforeCategorySelect.length > 0) {
                //
                //     vm.myDomainNotification.warningNames = angular.copy(vm.warningBeforeCategorySelect);
                //
                //     var categoryIds3 = [];
                //     vm.warningOptionsBeforeCategorySelect.forEach(oldWarningCat => {
                //         categoryIds3.push(oldWarningCat.warningCategory.id);
                //     })
                //     var fleetIds2 = [];
                //     vm.warningOptionsBeforeCategorySelect.forEach(function (oldWarningFleet) {
                //         fleetIds2.push(oldWarningFleet.tabFleets.id)
                //     })
                //
                //     vm.warningNameOptions.forEach(warningOption => {
                //         if (!categoryIds3.includes(warningOption.warningCategory.id) || !fleetIds2.includes(warningOption.tabFleets.id)) {
                //             vm.myDomainNotification.warningNames.push(warningOption);
                //         }
                //     })
                //
                // } else {
                //     vm.myDomainNotification.warningNames = angular.copy(vm.warningNameOptions);
                // }

            }

            function onCategoryDeselect(categories) {

                if (categories.length > 0) {

                    // vm.warningBeforeCategoryDeselect = angular.copy(vm.myDomainNotification.warningNames);
                    // vm.warningOptionsBeforeCategoryDeselect = angular.copy(vm.warningNameOptions);

                    vm.warningNameOptions = [];
                    vm.categoryEmpty = false;

                    var fleetOptionsIds3 = [];

                    vm.myDomainNotification.fleets.forEach(function (fleet) {
                        fleetOptionsIds3.push(fleet.id)
                    })

                    // Set warning name options
                    var warningNamesMap = new Map();
                    categories.forEach(category => {
                        vm.warningNames.forEach(warning => {
                            if (warning.warningCategory.id === category.id && fleetOptionsIds3.includes(warning.tabFleets.id)) {
                                warning.label = warning.name;
                                warningNamesMap.set(warning.name, warning);
                            }
                        })
                    })
                    vm.warningNameOptions = Array.from(warningNamesMap.values());

                    // Selected options that match by name remain selected, additional options are not selected automatically
                    var finalSelection = [];
                    vm.myDomainNotification.warningNames.forEach(selected => {

                        // 1. Retrieves full object by id
                        var fullObj = vm.warningNames.find(w => w.id === selected.id);
                        if (!fullObj) return;

                        // 2. Find object with same name in options
                        var match = vm.warningNameOptions.find(opt => opt.name === fullObj.name);
                        if (!match) return;

                        // 3. Add object to final selection
                        finalSelection.push(match);
                    });

                    vm.myDomainNotification.warningNames = finalSelection;

                    // var fleetIds2 = [];
                    // vm.warningNameOptions.forEach(warningOption => {
                    //     fleetIds2.push(warningOption.tabFleets.id);
                    // })
                    // for (var x = 0; x < vm.myDomainNotification.fleets.length; x++) {
                    //     if (!fleetIds2.includes(vm.myDomainNotification.fleets[x].id)) {
                    //         vm.myDomainNotification.fleets.splice(x, 1);
                    //     }
                    // }
                    // var fleetsIds3 = [];
                    // for (var z1 = 0; z1 < vm.myDomainNotification.fleets.length; z1++) {
                    //     fleetsIds3.push(vm.myDomainNotification.fleets[z1].id);
                    // }
                    // var categoryIds4 = [];
                    // vm.warningNames.forEach(warning => {
                    //     if (fleetsIds3.includes(warning.tabFleets.id)) {
                    //         categoryIds4.push(warning.warningCategory.id);
                    //     }
                    // })
                    // for (var z = 0; z < vm.categoryOptions.length; z++) {
                    //     if (!categoryIds4.includes(vm.categoryOptions[z].id)) {
                    //         vm.categoryOptions.splice(z, 1);
                    //     }
                    // }

                } else {
                    // vm.myDomainNotification.fleets = [];
                    // vm.fleetEmpty = true;

                    vm.categoryEmpty = true;

                    // Nessuna categoria selezionata > nessun warning name selezionato
                    vm.myDomainNotification.warningNames = [];
                }
            }

            function onWarningSelect(warnings) {}
            function onWarningDeselect(warnings) {}

            vm.categoryListSettings = {
                checkboxes: true,
                smartButtonMaxItems: 10,
                buttonDefaultText: "select fleet first",
                scrollable: true,
                enableSearch: true,
                clearSearchOnClose: true,
            };
            vm.warningListSettings = {
                checkboxes: true,
                smartButtonMaxItems: 10,
                buttonDefaultText: "select category first",
                scrollable: true,
                enableSearch: true,
                clearSearchOnClose: true,
            };
            vm.fleetListSettings = {
                checkboxes: true,
                smartButtonMaxItems: 10,
                buttonDefaultText: "select fleet(s)",
                scrollable: true,
                enableSearch: true,
                clearSearchOnClose: true,
            };

            vm.fleetListEvent = {
                onSelectAll: function () {
                    vm.myDomainNotification.fleets = angular.copy(vm.fleetOptions);
                    onFleetSelect(vm.myDomainNotification.fleets)
                },
                onDeselectAll: function () {
                    vm.myDomainNotification.fleets = [];
                    onFleetDeselect(vm.myDomainNotification.fleets)
                },
                onItemSelect: function () {
                    onFleetSelect(vm.myDomainNotification.fleets)
                },
                onItemDeselect: function () {
                    onFleetDeselect(vm.myDomainNotification.fleets)
                },
            };
            vm.categoryListEvent = {
                onSelectAll: function () {
                    vm.myDomainNotification.categories = angular.copy(vm.categoryOptions);
                    onCategorySelect(vm.myDomainNotification.categories)
                },
                onDeselectAll: function () {
                    vm.myDomainNotification.categories = [];
                    onCategoryDeselect(vm.myDomainNotification.categories)
                },
                onItemSelect: function () {
                    onCategorySelect(vm.myDomainNotification.categories)
                },
                onItemDeselect: function () {
                    onCategoryDeselect(vm.myDomainNotification.categories)
                },
            };
            vm.warningListEvent = {
                onSelectAll: function () {
                    vm.myDomainNotification.warningNames = angular.copy(vm.warningNameOptions);
                    onWarningSelect(vm.myDomainNotification.warningNames)
                },
                onDeselectAll: function () {
                    vm.myDomainNotification.warningNames = [];
                    onWarningDeselect(vm.myDomainNotification.warningNames)
                },
                onItemSelect: function () {
                    onWarningSelect(vm.myDomainNotification.warningNames)
                },
                onItemDeselect: function () {
                    onWarningDeselect(vm.myDomainNotification.warningNames)
                },
            };

            function collectFleets() {
                vm.selectedFleets = [];
                for (var x = 0; x < vm.tabFleets.length; x++) {
                    for (var i = 0; i < vm.myDomainNotification.fleets.length; i++) {
                        if (vm.tabFleets[x].id == vm.myDomainNotification.fleets[i].id) {
                            vm.selectedFleets.push(vm.tabFleets[x]);
                        }
                    }
                }
            }

            function collectCategories() {
                vm.selectedCategories = [];
                for (var x = 0; x < vm.categories.length; x++) {
                    for (var i = 0; i < vm.myDomainNotification.categories.length; i++) {
                        if (vm.categories[x].id == vm.myDomainNotification.categories[i].id && vm.myDomainNotification.categories[i].id != -1) {
                            vm.selectedCategories.push(vm.categories[x]);
                        }
                    }
                }
            }

            function collectWarnings() {
                vm.selectedWarnings = [];

                var selectedFleetIds = vm.myDomainNotification.fleets.map(f => f.id);
                var selectedCategoryIds = vm.myDomainNotification.categories.map(c => c.id);

                vm.myDomainNotification.warningNames.forEach(selected => {

                    // 1. Retrieves full object by id
                    var fullObj = vm.warningNames.find(w => w.id === selected.id);
                    if (!fullObj) return;

                    // 2. Retrieves rules by name
                    var rulesForName = vm.warningNameMap[fullObj.name] || [];

                    rulesForName.forEach(rule => {
                        // Controllo se la rule appartiene a una flotta e categoria selezionata
                        if (selectedFleetIds.includes(rule.tabFleets.id) &&
                            selectedCategoryIds.includes(rule.warningCategory.id)) {

                            // Creo una copia pulita (senza label)
                            var ruleCopy= Object.assign({}, rule);
                            delete ruleCopy.label;

                            vm.selectedWarnings.push(ruleCopy);
                        }
                    });
                });
            }


            vm.precompile = function () {

                vm.nameForTitle = angular.copy(vm.myDomainNotification.name);
                vm.systemWarningExists = false;

                if (vm.myDomainNotification.fleets.length > 0) {    // in case is edit or clone
                    if (vm.myDomainNotification.id != null) {
                        vm.isEdit = true;
                    }
                    if (vm.myDomainNotification.id == null) {
                        vm.isClone = true;
                    }
                    vm.myDomainNotification.fleets.forEach(function (fleet) {   // getting all the fleets from entity and set it inside the dropdown list as (id, label).
                        vm.fleetSelectedAtStart.push({id: fleet.id, label: fleet.fleetName});
                    });
                    vm.myDomainNotification.fleets = angular.copy(vm.fleetSelectedAtStart);

                    // Check for system warnings
                    vm.systemWarningExists = vm.myDomainNotification.warningNames.some(selected =>
                        selected.warningCategory == null
                    );

                    vm.myDomainNotification.categories.forEach(function (category) {   // getting all the categories from entity and set it inside the dropdown list as (id, label).
                        vm.categorySelectedAtStart.push({id: category.id, label: category.warningName});
                    });
                    vm.myDomainNotification.categories = angular.copy(vm.categorySelectedAtStart);

                    // Se c'è almeno un system warning, aggiungo la categoria {-1, 'system'}
                    if (vm.systemWarningExists) {
                        vm.myDomainNotification.categories.push({id: -1, warningName: "system"});
                    }

                    // --

                    var fleetIds4 = [];
                    vm.myDomainNotification.fleets.forEach(function (fleet) {
                        fleetIds4.push(fleet.id)
                    })

                    // Set warning name options
                    var warningNamesMap = new Map();
                    vm.myDomainNotification.categories.forEach(category => {
                        vm.warningNames.forEach(warning => {
                            if (warning.warningCategory.id === category.id && fleetIds4.includes(warning.tabFleets.id)) {
                                warning.label = warning.name;
                                warningNamesMap.set(warning.name, warning);
                            }
                        })
                    })
                    vm.warningNameOptions = Array.from(warningNamesMap.values());

                    // Dedupe rules by name before selection
                    vm.myDomainNotification.warningNames = dedupeByName(vm.myDomainNotification.warningNames);

                    // Selected options that match by name remain selected, additional options are not selected automatically
                    var finalSelection = [];
                    vm.myDomainNotification.warningNames.forEach(selected => {

                        if (selected.warningCategory == null) {
                            vm.systemWarningExists = true;
                        }

                        // 1. Retrieves full object by id
                        var fullObj = vm.warningNames.find(w => w.id === selected.id);
                        if (!fullObj) return;

                        // 2. Find object with same name in option list
                        var match = vm.warningNameOptions.find(opt => opt.name === fullObj.name);
                        if (!match) return;

                        // 3. Add object to final selection
                        finalSelection.push(match);
                    });

                    // Imposto la selezione iniziale senza duplicati
                    vm.warningSelectedAtStart = angular.copy(finalSelection);
                    vm.myDomainNotification.warningNames = angular.copy(vm.warningSelectedAtStart);

                    // --

                    var categoryIds8 = [];

                    vm.warningNames.forEach(warningOption => {
                        if (fleetIds4.includes(warningOption.tabFleets.id)) {
                            vm.categoryOptions.forEach(function (option) {
                                categoryIds8.push(option.id);
                            })
                            if (!categoryIds8.includes(warningOption.warningCategory.id))
                                vm.categoryOptions.push({
                                    id: warningOption.warningCategory.id,
                                    label: warningOption.warningCategory.warningName
                                });
                        }
                    })
                    vm.fleetEmpty = false;
                    vm.categoryEmpty = false;

                    var date = new Date(vm.myDomainNotification.nextExecutionDatetime);
                    vm.myDomainNotification.nextExecutionDatetime = angular.copy(date);

                } else {
                    vm.isCreate = true;
                    vm.myDomainNotification.userProfile = vm.currentUserProfile;
                }
            }

        }
    }

)
();
